/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Coinvestments_Tracking_Dealsclosedsuccessfully3Inputs */

const en_coinvestments_tracking_dealsclosedsuccessfully3 = /** @type {(inputs: Coinvestments_Tracking_Dealsclosedsuccessfully3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} opportunities closed successfully`)
};

/**
* | output |
* | --- |
* | "{count} opportunities closed successfully" |
*
* @param {Coinvestments_Tracking_Dealsclosedsuccessfully3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_tracking_dealsclosedsuccessfully3 = /** @type {((inputs: Coinvestments_Tracking_Dealsclosedsuccessfully3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Tracking_Dealsclosedsuccessfully3Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_tracking_dealsclosedsuccessfully3(inputs)
});
export { coinvestments_tracking_dealsclosedsuccessfully3 as "coInvestments_tracking_dealsClosedSuccessfully" }